import React from "react"
import {
    HorizontalStackSpaceBetween,
    LinkButton,
    ContrastButton,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import { useSharedStyles } from "~components/pages/search/search-filters/use-shared-styles"

interface Props {
    readonly handleClear: () => void
    readonly handleApply: () => void
}

export default function SearchFiltersModalFooter({
    handleClear,
    handleApply,
}: Props) {
    const styles = useStyleProps()
    const sharedStyles = useSharedStyles()

    return (
        <HorizontalStackSpaceBetween style={styles.footerButtons}>
            <LinkButton style={sharedStyles.linkButton} onClick={handleClear}>
                {COPY.CLEAR_ALL}
            </LinkButton>
            <ContrastButton onClick={handleApply}>
                {COPY.APPLY_FILTERS}
            </ContrastButton>
        </HorizontalStackSpaceBetween>
    )
}

function useStyleProps() {
    return {
        footerButtons: {
            width: "100%",
        },
    }
}
